import { IColumns } from '../../../components/Table'

export type BankAccountsColumnKeys = 'bankName' | 'currency' | 'bankAccountNumber' | 'actions'

export const bankAccountsColumns: IColumns<BankAccountsColumnKeys>[] = [
  {
    id: 'bankName',
    label: 'BANK',
  },
  {
    id: 'currency',
    label: 'CURRENCY',
  },
  {
    id: 'bankAccountNumber',
    label: 'ACCOUNT NUMBER',
  },
  {
    id: 'actions',
    label: 'ACTION',
  },
]

export type WalletsColumnKeys = 'address' | 'currency' | 'actions'

export const walletsColumns: IColumns<WalletsColumnKeys>[] = [
  {
    id: 'address',
    label: 'ADDRESS',
  },
  {
    id: 'currency',
    label: 'CURRENCY',
  },
  {
    id: 'actions',
    label: 'ACTION',
  },
]
